export default __webpack_public_path__ + "static/media/addressbook_external_icon.119f64de.svg";